// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"Documents_tabsWrapper__4tjUv","tabContent":"Documents_tabContent__3oTu4","tabError":"Documents_tabError__cmYau"};